let config = {
  apiKey: "AIzaSyCMWEAFE1GlWZkb6rCENNgwxXdZMSTMIk4",
  authDomain: "faves-web-dev.firebaseapp.com",
  databaseURL: "https://faves-web-dev.firebaseio.com",
  projectId: "faves-web-dev",
  storageBucket: "faves-web-dev.appspot.com",
  messagingSenderId: "138845984717",
  appId: "1:138845984717:web:75f53e97a69f1813351684",
  measurementId: "G-B90SN1WHK8"
};

export let square_url = "https://shopifyapp-138845984717.us-central1.run.app"
export let shopify_url = "https://favespro-ffcrmbeoja-uc.a.run.app"
export let photo_url = 'https://firebasestorage.googleapis.com/v0/b/faves-web-dev.appspot.com';
export let tag_url = 'https://firebasestorage.googleapis.com/v0/b/faves-web-dev-tags';
export let firebase_data_url = 'https://console.firebase.google.com/u/1/project/faves-web-dev/database/faves-web-dev/data';
export let default_country_code = '+45';

if (process.env.REACT_APP_ENV === 'prod') {
  config = {
    apiKey: "AIzaSyBGmGj2YphZsAaQNbvJmL6Pgw1eC006LRE",
    authDomain: "faves-pro.firebaseapp.com",
    databaseURL: "https://faves-pro.firebaseio.com",
    projectId: "faves-pro",
    storageBucket: "faves-pro.appspot.com",
    messagingSenderId: "997297102399",
    appId: "1:997297102399:web:ff29e61515257bb113a28a",
    measurementId: "G-9BWM0M5NHP",
  };
  square_url = "https://favespro-ffcrmbeoja-uc.a.run.app"
  photo_url = 'https://firebasestorage.googleapis.com/v0/b/faves-pro.appspot.com';
  tag_url = 'https://firebasestorage.googleapis.com/v0/b/faves-pro-tags';
  firebase_data_url = 'https://console.firebase.google.com/u/1/project/faves-pro/database/faves-pro/data';
  default_country_code = '+1';

  // <!-- hotjar analytics -->
  (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:4933219,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}

export default config;